import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import moment from 'moment';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import * as RestService from '../../services/eisRest';





  const ArticlePartModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
    const [articlePart, setArticlePart] = useState([]);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [validFromLong, setValidFromLong] = useState(new Date());
    const [validToLong, setValidToLong] = useState(new Date());
    const dialogRef = createRef();
    const [showArticleModalWithDatatable, setShowArticleModalWithDatatable] = useState(false);
    const [loadedArticlePart, setLoadedArticlePart] = useState();
    const [loadedMeasureUnit,setLoadedMeasureUnit] = useState();

    const handleOpenArticleList = () => {
      setShowArticleModalWithDatatable(true);
    }

    const handleCallback = (show,id) => {         
      setShowArticleModalWithDatatable(show);             
      getDataAboutArticlePart(id);
    };
    
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    const getDataAboutArticlePart = (id) => {
      RestService.callAnyApi('article/getArticle?id='+id, null)
      .then((data) => {
        setLoadedArticlePart(data);
        setLoadedMeasureUnit(data.measureUnit);
        formik.setFieldValue("name",data.name);
      })
      .catch((error) => {
        console.log(error);
      });
    }


    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('workOrder/getArticlePart?id='+props.selectedRecord, null)
      .then((data) => {
           getDataAboutArticlePart(data.partId);        
           setArticlePart(data);
           setValidFromLong(data.validFromLong);
           setValidToLong(data.validToLong);
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

   

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=articlePart&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
  //    articlePart.entityId=props.entityId;
    //  articlePart.bankId=values.bankId;
    //  articlePart.currency=values.currency;
    //  articlePart.departmentId=values.departmentId;
     // articlePart.iban=values.iban;
     articlePart.partId = loadedArticlePart.id;
     articlePart.qty=values.qty;     
     articlePart.position=values.position; 
     
     if(validFromLong==0){setValidFromLong(null);}
     if(validToLong==0){setValidToLong(null);}

     articlePart.validFromLong = validFromLong;
     articlePart.validToLong = validToLong;
     if(validFromLong==null){
      articlePart.validFrom = "";
     }else{
      articlePart.validFrom = moment(validFromLong).format('DD.MM.YYYY');
     }
     if(validToLong==null){
      articlePart.validTo = "";
     }else{
      articlePart.validTo = moment(validToLong).format('DD.MM.YYYY');
     }
    

      RestService.callAnyApi(url, articlePart)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

        qty : articlePart.qty,
        position : articlePart.position
       // bankId: articlePart.bankId || "",
       // currency: articlePart.currency || "",
       // departmentId: articlePart.departmentId || "",
       // iban: articlePart.iban || "",
      },
      validationSchema: Yup.object({
      //   bankId: Yup.string()     
      //    .required(t('general.message.required')),
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('workOrder/saveArticlePart?bomId='+entityId,values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                   
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('articlePart.label.articlePart')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                         <div className="row"> 
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('general.label.name')}</label>
                                    <input type="text" class="form-control" readOnly onClick={handleOpenArticleList} placeholder="" {...formik.getFieldProps('name')} />
                                  </div>
                                  {formik.touched.name && formik.errors.name ? (
                                    <div style={{ color: 'red' }}>{formik.errors.name}</div>
                                ) : null} 
                                </div>        
                          </div>

                          <div className="row">
                                <div className="col-6 col-sm-6 col-lg-6">
                                     <div className="form-group">
                                       <label>{t('document.label.qty')}</label>
                                       <input type="number" className="form-control"  {...formik.getFieldProps('qty')}  step="any"/>                                   
                                     </div>
                                </div>

                                <div className="col-3 col-sm-3 col-lg-3">
                                     <div className="form-group">
                                       <label>{t('article.label.measureUnit')}</label>
                                       <input type="text" readOnly className="form-control" value={loadedMeasureUnit} />                                   
                                     </div>
                                </div>
                          </div>

                          <div className="row">
                                <div className="col-6 col-sm-6 col-lg-6">
                                     <div className="form-group">
                                       <label>{t('articlePart.label.position')}</label>
                                       <input type="number" className="form-control"  {...formik.getFieldProps('position')}  step="any"/>                                   
                                     </div>
                                </div>
                          </div>      

                               <div className="row">

                                  <div className="col-3 col-sm-3 col-lg-3">
                                        <div className="form-group">
                                            <label>{t('partner.label.validFrom')}</label>                                                                               
                                            <DatePicker
                                                className='form-control'                                            
                                                selected={validFromLong}
                                                onChange={(value) => setValidFromLong(new Date(value).getTime())}
                                                dateFormat="dd.MM.yyyy"                                                                                                                                
                                            />                                                   						
                                        </div>
                                  </div>        


                                  <div className="col-3 col-sm-3 col-lg-3">
                                        <div className="form-group">
                                            <label>{t('partner.label.validTo')}</label>                                                                               
                                            <DatePicker
                                                className='form-control'                                            
                                                selected={validToLong}
                                                onChange={(value) => setValidToLong(new Date(value).getTime())}
                                                dateFormat="dd.MM.yyyy"                                                                                    
                                            />                                                   						
                                        </div>
                                  </div>   

                          </div>                                

                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button style={entityId ? {} : { display: 'none' }} className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

          <ArticleModalWithDatatable            
            parentCallback={handleCallback}    
            modal={showArticleModalWithDatatable}                                
          />
      </>
    );
  };

 export default ArticlePartModal;